<!-- src/components/rota/EmployeeStarterFormsPanel.vue -->
<template>
  <!-- CONTENT ONLY: no card, no container, no assumed sizing -->
  <form class="starter-forms" @submit.prevent="onSubmit">
    <!-- =============================== -->
    <!-- EMPLOYEE STARTER FORM           -->
    <!-- =============================== -->

    <section>
      <h5 style="margin: 0 0 10px 0">Employee Starter Form</h5>

      <div v-if="error" class="red-text text-darken-2" style="margin: 8px 0">
        {{ error }}
      </div>

      <!-- Personal Details -->
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m3">
          <input id="sf_title" v-model="form.title" type="text" :disabled="busyAll" />

          <label class="active" for="sf_title"> Title </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="sf_first"
            v-model="form.first_names"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_first"> First name(s) </label>
        </div>

        <div class="input-field col s12 m5">
          <input id="sf_last" v-model="form.last_name" type="text" :disabled="busyAll" />

          <label class="active" for="sf_last"> Last name </label>
        </div>
      </div>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m6">
          <input id="sf_ni" v-model="form.ni_number" type="text" :disabled="busyAll" />

          <label class="active" for="sf_ni"> National Insurance Number </label>
        </div>

        <div class="input-field col s12 m6">
          <input id="sf_dob" v-model="form.dob" type="date" :disabled="busyAll" />

          <label class="active" for="sf_dob"> Date of Birth </label>
        </div>
      </div>

      <!-- Address -->
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12">
          <input
            id="sf_addr1"
            v-model="form.address_line_1"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_addr1"> Address Line 1 </label>
        </div>
      </div>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m6">
          <input id="sf_city" v-model="form.town_city" type="text" :disabled="busyAll" />

          <label class="active" for="sf_city"> Town / City </label>
        </div>

        <div class="input-field col s12 m6">
          <input id="sf_post" v-model="form.postcode" type="text" :disabled="busyAll" />

          <label class="active" for="sf_post"> Postcode </label>
        </div>
      </div>

      <!-- Contact -->
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m6">
          <input id="sf_phone" v-model="form.phone" type="tel" :disabled="busyAll" />

          <label class="active" for="sf_phone"> Phone Number </label>
        </div>

        <div class="input-field col s12 m6">
          <input id="sf_email" v-model="form.email" type="email" :disabled="busyAll" />

          <label class="active" for="sf_email"> Email Address </label>
        </div>
      </div>

      <!-- Employment -->
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m6">
          <input
            id="sf_start"
            v-model="form.start_date"
            type="date"
            :disabled="busyAll"
          />

          <label class="active" for="sf_start"> Start Date </label>
        </div>

        <div class="input-field col s12 m6">
          <input id="sf_job" v-model="form.job_title" type="text" :disabled="busyAll" />

          <label class="active" for="sf_job"> Job Title </label>
        </div>
      </div>

      <!-- Bank -->
      <h6 style="margin: 16px 0 6px 0">Bank Details</h6>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m6">
          <input
            id="sf_accname"
            v-model="form.bank_account_name"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_accname"> Account Name </label>
        </div>

        <div class="input-field col s12 m3">
          <input
            id="sf_sort"
            v-model="form.bank_sort_code"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_sort"> Sort Code </label>
        </div>

        <div class="input-field col s12 m3">
          <input
            id="sf_accno"
            v-model="form.bank_account_number"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_accno"> Account Number </label>
        </div>
      </div>

      <!-- Uploads -->
      <h6 style="margin: 16px 0 6px 0">Uploads</h6>

      <div class="row" style="margin-bottom: 0">
        <!-- Passport -->
        <div class="col s12 m6" style="margin-bottom: 12px">
          <label
            class="grey-text text-darken-1"
            style="display: block; font-size: 12px; margin-bottom: 6px"
          >
            Passport (optional)
          </label>

          <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap">
            <label
              class="btn"
              :class="{ disabled: busyAll }"
              style="position: relative; overflow: hidden"
            >
              <span> Upload Passport </span>

              <input
                type="file"
                accept="image/*,.pdf"
                :disabled="busyAll"
                style="position: absolute; inset: 0; opacity: 0; cursor: pointer"
                @change="onFilePicked('passport', $event)"
              />
            </label>

            <span class="grey-text text-darken-1" style="font-size: 12px">
              {{ passportFileLabel }}
            </span>

            <a
              v-if="passportFile"
              class="btn-flat"
              href="#"
              :class="{ disabled: busyAll }"
              @click.prevent="clearFile('passport')"
            >
              Clear
            </a>
          </div>
        </div>

        <!-- Proof of Address -->
        <div class="col s12 m6" style="margin-bottom: 12px">
          <label
            class="grey-text text-darken-1"
            style="display: block; font-size: 12px; margin-bottom: 6px"
          >
            Proof of Address (optional)
          </label>

          <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap">
            <label
              class="btn"
              :class="{ disabled: busyAll }"
              style="position: relative; overflow: hidden"
            >
              <span> Upload Proof of Address </span>

              <input
                type="file"
                accept="image/*,.pdf"
                :disabled="busyAll"
                style="position: absolute; inset: 0; opacity: 0; cursor: pointer"
                @change="onFilePicked('proof', $event)"
              />
            </label>

            <span class="grey-text text-darken-1" style="font-size: 12px">
              {{ proofFileLabel }}
            </span>

            <a
              v-if="proofFile"
              class="btn-flat"
              href="#"
              :class="{ disabled: busyAll }"
              @click.prevent="clearFile('proof')"
            >
              Clear
            </a>
          </div>
        </div>
      </div>

      <!-- Share code (optional) + certificate upload (optional) -->
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m6">
          <input
            id="sf_sharecode"
            v-model="form.share_code"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_sharecode"> Share Code (optional) </label>
        </div>

        <div class="col s12 m6" style="margin-bottom: 12px; margin-top: 18px">
          <label
            class="grey-text text-darken-1"
            style="display: block; font-size: 12px; margin-bottom: 6px"
          >
            Share Code Certificate (optional)
          </label>

          <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap">
            <label
              class="btn"
              :class="{ disabled: busyAll }"
              style="position: relative; overflow: hidden"
            >
              <span> Upload Share Code Certificate </span>

              <input
                type="file"
                accept="image/*,.pdf"
                :disabled="busyAll"
                style="position: absolute; inset: 0; opacity: 0; cursor: pointer"
                @change="onFilePicked('sharecode', $event)"
              />
            </label>

            <span class="grey-text text-darken-1" style="font-size: 12px">
              {{ shareCodeFileLabel }}
            </span>

            <a
              v-if="shareCodeFile"
              class="btn-flat"
              href="#"
              :class="{ disabled: busyAll }"
              @click.prevent="clearFile('sharecode')"
            >
              Clear
            </a>
          </div>
        </div>
      </div>

      <!-- Declaration -->
      <h6 style="margin: 16px 0 6px 0">Declaration</h6>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m8">
          <input
            id="sf_sig"
            v-model="form.signature_name"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="sf_sig"> Employee Signature (type name) </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="sf_sigdate"
            v-model="form.signature_date"
            type="date"
            :disabled="busyAll"
          />

          <label class="active" for="sf_sigdate"> Date Signed </label>
        </div>
      </div>
    </section>

    <!-- =============================== -->
    <!-- EMERGENCY CONTACT FORM          -->
    <!-- =============================== -->

    <section style="margin-top: 18px">
      <h5 style="margin: 0 0 10px 0">Emergency Contact Information</h5>

      <h6 style="margin: 12px 0 6px 0">Primary Contact</h6>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m4">
          <input
            id="ec_p_fn"
            v-model="form.emergency_primary_first"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="ec_p_fn"> First Name </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_p_ln"
            v-model="form.emergency_primary_last"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="ec_p_ln"> Last Name </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_p_rel"
            v-model="form.emergency_primary_relationship"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="ec_p_rel"> Relationship </label>
        </div>
      </div>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m4">
          <input
            id="ec_p_home"
            v-model="form.emergency_primary_home_phone"
            type="tel"
            :disabled="busyAll"
          />

          <label class="active" for="ec_p_home"> Home Phone </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_p_mobile"
            v-model="form.emergency_primary_mobile_phone"
            type="tel"
            :disabled="busyAll"
          />

          <label class="active" for="ec_p_mobile"> Mobile Phone </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_p_work"
            v-model="form.emergency_primary_work_phone"
            type="tel"
            :disabled="busyAll"
          />

          <label class="active" for="ec_p_work"> Work Phone </label>
        </div>
      </div>

      <h6 style="margin: 12px 0 6px 0">Secondary Contact</h6>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m4">
          <input
            id="ec_s_fn"
            v-model="form.emergency_secondary_first"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="ec_s_fn"> First Name </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_s_ln"
            v-model="form.emergency_secondary_last"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="ec_s_ln"> Last Name </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_s_rel"
            v-model="form.emergency_secondary_relationship"
            type="text"
            :disabled="busyAll"
          />

          <label class="active" for="ec_s_rel"> Relationship </label>
        </div>
      </div>

      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12 m4">
          <input
            id="ec_s_home"
            v-model="form.emergency_secondary_home_phone"
            type="tel"
            :disabled="busyAll"
          />

          <label class="active" for="ec_s_home"> Home Phone </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_s_mobile"
            v-model="form.emergency_secondary_mobile_phone"
            type="tel"
            :disabled="busyAll"
          />

          <label class="active" for="ec_s_mobile"> Mobile Phone </label>
        </div>

        <div class="input-field col s12 m4">
          <input
            id="ec_s_work"
            v-model="form.emergency_secondary_work_phone"
            type="tel"
            :disabled="busyAll"
          />

          <label class="active" for="ec_s_work"> Work Phone </label>
        </div>
      </div>
    </section>

    <!-- Actions (minimal; modal can hide via prop) -->
    <div
      v-if="showActions"
      style="margin-top: 16px; display: flex; gap: 10px; flex-wrap: wrap"
    >
      <button class="btn" type="submit" :disabled="busyAll">
        {{ busyAll ? "Submitting..." : "Submit" }}
      </button>

      <a
        class="btn-flat"
        href="#"
        :class="{ disabled: busyAll }"
        @click.prevent="$emit('cancel')"
      >
        Cancel
      </a>
    </div>
  </form>
</template>

<script>
import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";

import { getStorage, ref as sRef, uploadBytes, getDownloadURL } from "firebase/storage";

import { db, auth } from "@/firebase";

function clean(v) {
  return String(v ?? "").trim();
}

function safeFileName(name) {
  return (
    clean(name)
      .replace(/[^\w.\-]+/g, "_")
      .slice(0, 120) || "file"
  );
}

export default {
  name: "EmployeeStarterFormsPanel",

  props: {
    venueId: {
      type: String,
      required: true,
    },

    staffId: {
      type: String,
      default: "",
    },

    showActions: {
      type: Boolean,
      default: true,
    },

    busy: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      busyLocal: false,
      error: null,

      passportFile: null,
      proofFile: null,
      shareCodeFile: null,

      form: {
        title: "",
        first_names: "",
        last_name: "",
        ni_number: "",
        dob: "",
        address_line_1: "",
        town_city: "",
        postcode: "",
        phone: "",
        email: "",
        start_date: "",
        job_title: "",
        bank_account_name: "",
        bank_sort_code: "",
        bank_account_number: "",

        share_code: "",

        signature_name: "",
        signature_date: "",

        emergency_primary_first: "",
        emergency_primary_last: "",
        emergency_primary_relationship: "",
        emergency_primary_home_phone: "",
        emergency_primary_mobile_phone: "",
        emergency_primary_work_phone: "",

        emergency_secondary_first: "",
        emergency_secondary_last: "",
        emergency_secondary_relationship: "",
        emergency_secondary_home_phone: "",
        emergency_secondary_mobile_phone: "",
        emergency_secondary_work_phone: "",
      },
    };
  },

  computed: {
    busyAll() {
      return !!this.busy || this.busyLocal;
    },

    passportFileLabel() {
      return this.passportFile ? this.passportFile.name : "No file selected";
    },

    proofFileLabel() {
      return this.proofFile ? this.proofFile.name : "No file selected";
    },

    shareCodeFileLabel() {
      return this.shareCodeFile ? this.shareCodeFile.name : "No file selected";
    },
  },

  methods: {
    onFilePicked(kind, e) {
      const f = e?.target?.files?.[0] || null;

      if (kind === "passport") {
        this.passportFile = f;
      }

      if (kind === "proof") {
        this.proofFile = f;
      }

      if (kind === "sharecode") {
        this.shareCodeFile = f;
      }

      if (e?.target) {
        e.target.value = "";
      }
    },

    clearFile(kind) {
      if (kind === "passport") {
        this.passportFile = null;
      }

      if (kind === "proof") {
        this.proofFile = null;
      }

      if (kind === "sharecode") {
        this.shareCodeFile = null;
      }
    },

    validate() {
      if (!clean(this.venueId)) {
        return "Missing venueId.";
      }

      if (!clean(this.form.first_names) || !clean(this.form.last_name)) {
        return "Please enter first name(s) and last name.";
      }

      if (!clean(this.form.start_date)) {
        return "Please enter a start date.";
      }

      if (!clean(this.form.signature_name) || !clean(this.form.signature_date)) {
        return "Please sign and date the declaration.";
      }

      return null;
    },

    async onSubmit() {
      try {
        this.error = null;

        const vErr = this.validate();

        if (vErr) {
          this.error = vErr;

          return;
        }

        this.busyLocal = true;

        const uid = auth?.currentUser?.uid || null;

        const baseData = {
          venue_id: clean(this.venueId),

          staff_id: clean(this.staffId) || null,

          form_type: "starter_forms",

          status: "submitted",

          title: clean(this.form.title),

          first_names: clean(this.form.first_names),

          last_name: clean(this.form.last_name),

          ni_number: clean(this.form.ni_number),

          dob: clean(this.form.dob),

          address_line_1: clean(this.form.address_line_1),

          town_city: clean(this.form.town_city),

          postcode: clean(this.form.postcode),

          phone: clean(this.form.phone),

          email: clean(this.form.email),

          start_date: clean(this.form.start_date),

          job_title: clean(this.form.job_title),

          bank_account_name: clean(this.form.bank_account_name),

          bank_sort_code: clean(this.form.bank_sort_code),

          bank_account_number: clean(this.form.bank_account_number),

          share_code: clean(this.form.share_code),

          signature_name: clean(this.form.signature_name),

          signature_date: clean(this.form.signature_date),

          emergency_primary: {
            first: clean(this.form.emergency_primary_first),

            last: clean(this.form.emergency_primary_last),

            relationship: clean(this.form.emergency_primary_relationship),

            home_phone: clean(this.form.emergency_primary_home_phone),

            mobile_phone: clean(this.form.emergency_primary_mobile_phone),

            work_phone: clean(this.form.emergency_primary_work_phone),
          },

          emergency_secondary: {
            first: clean(this.form.emergency_secondary_first),

            last: clean(this.form.emergency_secondary_last),

            relationship: clean(this.form.emergency_secondary_relationship),

            home_phone: clean(this.form.emergency_secondary_home_phone),

            mobile_phone: clean(this.form.emergency_secondary_mobile_phone),

            work_phone: clean(this.form.emergency_secondary_work_phone),
          },

          uploads: {
            passport: null,
            proof_of_address: null,
            share_code_certificate: null,
          },

          submitted_by_uid: uid,

          created_at: serverTimestamp(),

          updated_at: serverTimestamp(),
        };

        const colRef = collection(
          db,
          "venues",
          clean(this.venueId),
          "staff_starter_forms"
        );

        const created = await addDoc(colRef, baseData);

        const storage = getStorage();

        const patch = {
          uploads: {
            passport: null,
            proof_of_address: null,
            share_code_certificate: null,
          },

          updated_at: serverTimestamp(),
        };

        if (this.passportFile) {
          const objectName = `passport_${Date.now()}_${safeFileName(
            this.passportFile.name
          )}`;

          const path = `venues/${clean(this.venueId)}/staff_starter_forms/${
            created.id
          }/${objectName}`;

          const r = sRef(storage, path);

          await uploadBytes(r, this.passportFile, {
            contentType: this.passportFile.type || undefined,
          });

          const url = await getDownloadURL(r);

          patch.uploads.passport = {
            url,
            path,

            name: this.passportFile.name,

            size: this.passportFile.size,

            type: this.passportFile.type || null,

            uploaded_at: new Date().toISOString(),
          };
        }

        if (this.proofFile) {
          const objectName = `proof_of_address_${Date.now()}_${safeFileName(
            this.proofFile.name
          )}`;

          const path = `venues/${clean(this.venueId)}/staff_starter_forms/${
            created.id
          }/${objectName}`;

          const r = sRef(storage, path);

          await uploadBytes(r, this.proofFile, {
            contentType: this.proofFile.type || undefined,
          });

          const url = await getDownloadURL(r);

          patch.uploads.proof_of_address = {
            url,
            path,

            name: this.proofFile.name,

            size: this.proofFile.size,

            type: this.proofFile.type || null,

            uploaded_at: new Date().toISOString(),
          };
        }

        if (this.shareCodeFile) {
          const objectName = `share_code_certificate_${Date.now()}_${safeFileName(
            this.shareCodeFile.name
          )}`;

          const path = `venues/${clean(this.venueId)}/staff_starter_forms/${
            created.id
          }/${objectName}`;

          const r = sRef(storage, path);

          await uploadBytes(r, this.shareCodeFile, {
            contentType: this.shareCodeFile.type || undefined,
          });

          const url = await getDownloadURL(r);

          patch.uploads.share_code_certificate = {
            url,
            path,

            name: this.shareCodeFile.name,

            size: this.shareCodeFile.size,

            type: this.shareCodeFile.type || null,

            uploaded_at: new Date().toISOString(),
          };
        }

        const hasAnyUpload = !!(
          patch.uploads.passport ||
          patch.uploads.proof_of_address ||
          patch.uploads.share_code_certificate
        );

        if (hasAnyUpload) {
          await updateDoc(
            doc(db, "venues", clean(this.venueId), "staff_starter_forms", created.id),
            patch
          );
        } else {
          await updateDoc(
            doc(db, "venues", clean(this.venueId), "staff_starter_forms", created.id),
            {
              updated_at: serverTimestamp(),
            }
          );
        }

        this.$emit("submitted", {
          id: created.id,

          venue_id: clean(this.venueId),

          staff_id: clean(this.staffId) || null,
        });

        this.resetForm();
      } catch (e) {
        this.error = e?.message || String(e);
      } finally {
        this.busyLocal = false;
      }
    },

    resetForm() {
      this.passportFile = null;

      this.proofFile = null;

      this.shareCodeFile = null;

      this.form = {
        title: "",
        first_names: "",
        last_name: "",
        ni_number: "",
        dob: "",
        address_line_1: "",
        town_city: "",
        postcode: "",
        phone: "",
        email: "",
        start_date: "",
        job_title: "",
        bank_account_name: "",
        bank_sort_code: "",
        bank_account_number: "",

        share_code: "",

        signature_name: "",
        signature_date: "",

        emergency_primary_first: "",
        emergency_primary_last: "",
        emergency_primary_relationship: "",
        emergency_primary_home_phone: "",
        emergency_primary_mobile_phone: "",
        emergency_primary_work_phone: "",

        emergency_secondary_first: "",
        emergency_secondary_last: "",
        emergency_secondary_relationship: "",
        emergency_secondary_home_phone: "",
        emergency_secondary_mobile_phone: "",
        emergency_secondary_work_phone: "",
      };
    },
  },
};
</script>

<style scoped>
.starter-forms {
  width: 100%;
}

.starter-forms section {
  min-width: 0;
}

@media (max-width: 600px) {
  .starter-forms h5 {
    font-size: 1.55rem;
    line-height: 1.25;
  }

  .starter-forms h6 {
    font-size: 1.05rem;
    line-height: 1.3;
  }

  .starter-forms label.btn {
    margin-bottom: 6px;
  }

  .starter-forms label.btn + .grey-text,
  .starter-forms label.btn ~ .grey-text {
    display: block;
    width: 100%;
    overflow-wrap: anywhere;
  }

  .starter-forms .btn-flat {
    width: 100% !important;
    text-align: center;
  }

  .starter-forms div[style*="display: flex"],
  .starter-forms div[style*="display:flex"] {
    align-items: stretch !important;
  }

  .starter-forms div[style*="margin-top: 16px"][style*="display: flex"],
  .starter-forms div[style*="margin-top: 16px"][style*="display:flex"] {
    flex-direction: column;
  }
}
</style>
